import { ChangeEventHandler, useCallback, useMemo } from "react";
import {
    TextField,
} from "@mui/material";
import { QuestionInterfaceProps } from "../types";
import { BASIC_TEXT, BasicTextInputValue } from "./basic-text-typedef";
import { basicTextValidate } from "./basic-text-validate";

export const BasicTextInput = ({ question, setQuestionState, questionState }: QuestionInterfaceProps<BasicTextInputValue>) => {
    const { valid, dirty, value } = questionState;
    const { voting_config } = question;
    const { multiline } = voting_config || {};

    const text_input = value && value.text_input ? value.text_input : "";

    const handleChange: ChangeEventHandler<HTMLInputElement> = useCallback((event) => {

        const voteValue = {
            text_input: event.target.value
        }

        const validation = basicTextValidate(question, voteValue);

        setQuestionState(state => ({
            ...state,
            valid: validation.valid,
            invalid_reasons: validation.reasons,
            data_version: BASIC_TEXT.VERSION,
            value: {
                text_input: event.target.value
            }
        }))

    }, [setQuestionState, question])

    return (
        <TextField value={text_input}
            onChange={handleChange}
            error={dirty && !valid}
            fullWidth
            multiline={multiline}
            rows={typeof multiline === 'number' ? multiline : undefined}
        />
    );
};
